<template>
  <section>
    <form
      @submit="onSubmit"
      v-if="hideForm === false"
      class="c-form"
    >
      <h3 class="c-form__title">
        {{ title }}
      </h3>
      <div
        v-if="lead"
        v-html="lead"
        class="c-form__lead"
      />
      <p class="c-form__label-and-input">
        <label for="name">Navn*</label>
        <input
          id="name"
          v-model="formInput.name"
          type="text"
          name="name"
          required
        >
      </p>
      <p class="c-form__label-and-input">
        <label for="email">E-post*</label>
        <input
          id="email"
          v-model="formInput.email"
          type="email"
          name="email"
          required
        >
      </p>
      <p class="c-form__label-and-input">
        <label for="phone">Telefon*</label>
        <input
          id="phone"
          v-model="formInput.phone"
          type="text"
          name="phone"
          required
        >
      </p>
      <p class="c-form__label-and-input">
        <input
          id="consent"
          v-model="formInput.consent"
          :value="consent"
          type="checkbox"
          name="consent"
          required
        >
        <label for="consent">
          {{ consent }}
        </label>
      </p>
      <button
        :disabled="formInput.consent != true"
        type="submit"
        title="Du må godkjenne før du kan sende inn skjemaet"
      >
        Send
      </button>
    </form>
    <div
      v-else
      class="c-form"
    >
      <h2>Tusen takk.</h2>
      <p>Vi har nå mottatt din melding og vil kontakte deg snarest.</p>
      <button
        @click="showForm"
        @keyup.enter="showForm"
        type="button"
        class="c-btn
        c-btn--secondary"
      >
        Vis skjemaet igjen
      </button>
    </div>
  </section>
</template>

<script>
import { required, minLength, } from 'vuelidate/lib/validators';
import axios from 'axios';
import querystring from 'querystring';

import Option from '@/models/Option';
import Residence from '@/models/Residence';

export default {
  name: 'ContactForm',
  props: {
    residenceId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      formInput: {
        name: '',
        email: '',
        phone: '',
        consent: '',
      },
      hideForm: false,
    };
  },
  computed: {
    residence() {
      return Residence.find(this.residenceId);
    },
    options() {
      return Option.query()
        .where('isSelected', true)
        .with('category')
        .get();
    },
    title() {
      return window.__selector_settings__.contactForm.title;
    },
    lead() {
      return window.__selector_settings__.contactForm.lead;
    },
    consent() {
      return window.__selector_settings__.contactForm.consent;
    },
    url() {
      const baseURL = window.__selector_settings__.sourceData.sourceURL;
      const contactFormId = window.__selector_settings__.contactForm.contactForm;
      if (baseURL != false) {
        return baseURL + '/wp-json/contact-form-7/v1/contact-forms/' + contactFormId + '/feedback';
      } else {
        return '/wp-json/contact-form-7/v1/contact-forms/' + contactFormId + '/feedback';
      }
    },
    info() {
      let values = {};
      values.navn = this.formInput.name;
      values.epost = this.formInput.email;
      values.telefon = this.formInput.phone;
      values.samtykke = this.formInput.consent;
      values.bolignavn = this.residence.name;

      values.tilvalg = '';
      this.options.forEach(option => {
        values.tilvalg +=
          option.category.name +
          ': ' +
          option.name +
          ', ' +
          option.currentPrice.toLocaleString('nb-NO') +
          ',–, \n';
      });
      return values;
    },
  },
  methods: {
    onSubmit(e) {
      e.preventDefault();
      this.$gtag.event('generate_lead', {
        event_category: 'engagement',
        event_label: `Meld interesse for ${this.residence.name}`,
        value: 1,
      });
      axios.post(
        this.url,
        querystring.stringify(this.info)
      )
        .then(res => {
          this.hideForm = true;
          //console.log(res);
        });
    },
    showForm() {
      this.hideForm = false;
    },
  },
};
</script>
